module.exports = __webpack_public_path__ + "static/flying-monies-60a6c0d0f386c4ddcf47edffdfb1267d.png";